import './Success.less';
export { default as Success } from './Success.js';
export { default } from './Success.js';